import { getRepresentanteModalidadeComercial } from '../../domain/representante-modalidade-comercial.enum';
import { Faturamento } from './faturamento';

/** Dados dos KPIs de uma modalidade comercial */
export class ModalidadeComercial {
    id: number;
    nome: string;
    descricao: string;
    backgroundColor: string;
    color: string;
    // Faturamento
    faturamento: Faturamento;

    constructor(props: Partial<ModalidadeComercial>) {
        Object.assign(this, props);

        if (props) {
            const modalidadeComercial = getRepresentanteModalidadeComercial(props.id);
            if (modalidadeComercial) {
                this.descricao = modalidadeComercial.descricao;
                this.backgroundColor = modalidadeComercial.backgroundColor;
                this.color = modalidadeComercial.color;
            }

            // Faturamento
            this.faturamento = props.faturamento ? new Faturamento(props.faturamento) : null;
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ModalidadeComercial {
        return new ModalidadeComercial(JSON.parse(json));
    }
}
